import { frontendURL } from '../../../helper/URLHelper';

const AgentAIActivationRoute = () =>
  import('./components/AgentAIActivationRoute');
const AgentAIChatbotTestWrapper = () =>
  import('./components/AgentAIChatbotTestWrapper');
const AgentAIInformationWrapper = () =>
  import('./components/AgentAIInformationWrapper');
const AgentAIOverviewWrapper = () =>
  import('./components/AgentAIOverviewWrapper');

const redirectTo =
  (name, canonicalQuery = {}, hash = '') =>
  (to) => ({
    name,
    params: to.params,
    query: { ...to.query, ...canonicalQuery },
    hash: hash || to.hash,
  });

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/hotel-data'),
      name: 'hotel_data',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_overview'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/overview'),
      name: 'agent_ai_overview',
      roles: ['administrator'],
      component: AgentAIOverviewWrapper,
    },
    {
      // Percorso contestuale per le conferme usate dal funnel onboarding.
      // Resta fuori dalle due destinazioni primarie ed e' raggiunto dalle
      // attivita' della Panoramica solo quando serve completarlo.
      // Con il percorso di attivazione acceso (onboarding_plan nel GET
      // agent_ai) qui c'e' la conversazione di attivazione, o il riepilogo a
      // percorso completato: lo decide AgentAIActivationRoute. La Panoramica
      // (e quindi /hotel-data) porta qui da sola in quel caso.
      path: frontendURL('accounts/:accountId/hotel-data/live'),
      name: 'agent_ai_golive',
      roles: ['administrator'],
      component: AgentAIActivationRoute,
    },
    {
      // Deep link storico: il flusso di correzione ora parte da
      // Conoscenza > Istruzioni dopo aver scelto il canale.
      path: frontendURL('accounts/:accountId/hotel-data/correct'),
      name: 'agent_ai_correct',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_information', { section: 'rules' }),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/information'),
      name: 'agent_ai_information',
      roles: ['administrator'],
      component: AgentAIInformationWrapper,
    },
    {
      // Deep link storico: dati, fonti e regole ora vivono insieme.
      path: frontendURL('accounts/:accountId/hotel-data/structure'),
      name: 'agent_ai_structure',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_information', { section: 'sources' }),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/channels'),
      name: 'agent_ai_channels',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_email_whatsapp_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/source'),
      name: 'agent_ai_source',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_information', { section: 'sources' }),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/internal'),
      name: 'agent_ai_internal',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_email_whatsapp_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/email-whatsapp'),
      name: 'agent_ai_email_whatsapp',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_email_whatsapp_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/chatbot'),
      name: 'agent_ai_chatbot',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_chatbot_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/voice'),
      name: 'agent_ai_voice',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_voice_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/memory'),
      name: 'agent_ai_memory',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_information', { section: 'rules' }),
    },
    {
      // I comandi rapidi vivono in una sottovoce dedicata delle impostazioni:
      // manteniamo il nome per i vecchi link salvati.
      path: frontendURL('accounts/:accountId/hotel-data/commands'),
      name: 'hotel_data_commands',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_quick_commands_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/documents'),
      name: 'hotel_data_documents',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_information', { section: 'sources' }),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/automations'),
      name: 'hotel_data_automations',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_automations_settings_index'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/manual'),
      name: 'agent_ai_manual',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_overview'),
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/test'),
      name: 'agent_ai_test',
      roles: ['administrator'],
      component: AgentAIChatbotTestWrapper,
    },
    {
      path: frontendURL('accounts/:accountId/hotel-data/activity'),
      name: 'agent_ai_activity',
      roles: ['administrator'],
      redirect: redirectTo('agent_ai_overview'),
    },
  ],
};
